import fetch from "@/fetch";
// 图书借阅/预约列表获取
export const alephUserInfoList = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/mine/alephuserinfo",
    data: params,
    loading: true,
    actionTypeCode: '26',
    actionTypeDesc: '图书借阅/预约列表获取',
  });
};
// 图书续借
export const alephRenew = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/mine/renew",
    data: params,
    loading: true,
    actionTypeCode: '27',
    actionTypeDesc: '图书续借',
  });
};
// 图书预约取消
export const alephCancel = (params) => {
  return fetch({
    method: "post",
    url: "/console/h5/mine/holdreqcancel",
    data: params,
    loading: true,
    actionTypeCode: '28',
    actionTypeDesc: '图书预约取消',
  });
};
